<script>
import request from "../modules/request";

export default {
  async mounted() {
    await this.getSettings();
  },
  data() {
    return {
      settings: {
        branding: {
          logo: "",
        },
        portalLogic: {
          logo: "",
        },
      },
    };
  },
  methods: {
    async getSettings() {
      const settings = await request.callInternal({
        method: "get",
        route: "/api/settings",
      });
      this.settings = settings.data;
    },
  },
};
</script>
